import parse from "./parse";
import serialize from "./serialize";

export default {
	parse,
	serialize,
};
